import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, RadioGroup, FormControlLabel, Radio, TextField, CircularProgress, Alert
} from "@mui/material";
import { getComplaintPermissionDetails, saveComplaintPermission, updateComplaintPermission, sendComplaintToDO } from "../services/complaintService";

const ComplaintPermissionViewDialog = ({ open, onClose, appId, labTypeId, orgIdCab,onRefresh }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isComplaint, setIsComplaint] = useState("");
  const [remarks, setRemarks] = useState("");
  const [mode, setMode] = useState("save"); // "save" or "update"
  const [showSend, setShowSend] = useState(false);

  useEffect(() => {
    if (open && appId) {
      setLoading(true);
      setError("");
      getComplaintPermissionDetails(appId)
        .then((res) => {
          if (res.success) {
            setIsComplaint(res.data.IsComplaint? Array.isArray(res.data.IsComplaint) ? res.data.IsComplaint[0] : res.data.IsComplaint : "");
            setRemarks(res.data.CCell_Remarks || "");
            setMode(res.data.IsComplaint ? "update" : "save");
            setShowSend(res.data.Stage !== "15bb" && !!res.data.IsComplaint);
          } else {
            setError(res.message || "Failed to load details");
          }
        })
        .catch(() => setError("Error loading details"))
        .finally(() => setLoading(false));
    }
  }, [open, appId]);

  const handleSaveOrUpdate = () => {
    setLoading(true);
    setError("");
    const apiCall = mode === "save" ? saveComplaintPermission : updateComplaintPermission;
    apiCall({ appId, isComplaint, remarks })
      .then((res) => {
        if (res.success) {
          setMode("update");
          setShowSend(true);
        } else {
          setError(res.message || "Failed to save");
        }
      })
      .catch(() => setError("Error saving"))
      .finally(() => setLoading(false));
  };

  const handleSend = () => {
    setLoading(true);
    setError("");
    sendComplaintToDO({ appId })
      .then((res) => {
        if (res.success) {  
          alert( res.message || "Complaint sent successfully");
          onClose && onClose();
          onRefresh && onRefresh();
        } else {
          setError(res.message || "Failed to send");
        }
      })
      .catch(() => setError("Error sending"))
      .finally(() => setLoading(false));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Complaint Permission</DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            {error && <Alert severity="error">{error}</Alert>}
            <div>
              <div>
                Whether there is any ongoing complaint against CAB? *
                <br />
                (Please confirm from Complaint Cell)
              </div>
              <RadioGroup
                row
                value={isComplaint}
                onChange={(e) => setIsComplaint(e.target.value)}
              >
                <FormControlLabel value="1" control={<Radio />} label="Yes" />
                <FormControlLabel value="0" control={<Radio />} label="No" />
              </RadioGroup>
            </div>
            <div>
              <TextField
                label="Remarks"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                fullWidth
                multiline
                required
                margin="normal"
              />
            </div>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button
          onClick={handleSaveOrUpdate}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {mode === "save" ? "Save" : "Update"}
        </Button>
        {showSend && (
          <Button
            onClick={handleSend}
            variant="contained"
            color="success"
            disabled={loading}
          >
            Send
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ComplaintPermissionViewDialog;
